import React from "react";
import { SeparatorLine } from "./separator-styles";

export const Separator = ({ vertical }) => (
  <SeparatorLine $width={vertical ? "1px" : "100%"} $height={vertical ? "100%" : "1px"} />
);
